export const environment = {
  production: false,
  BaseURL: 'https://demobackend.unimextech.com/',
};
